import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PartnerCodeInfoStepService } from '../../services/partner-code-info-step.service';
import { PartnerCodeStateService } from '../../services/partner-code-state.service';

@Component({
  selector: 'app-partner-code-card-information',
  templateUrl: './partner-code-card-information.component.html',
  styleUrls: ['./partner-code-card-information.component.css']
})
export class PartnerCodeCardInformationComponent implements OnInit {

  hideNavigation = false;

  constructor(
    private partnerCodeInfoStepService: PartnerCodeInfoStepService,
    private partnerCodeStateService: PartnerCodeStateService,
  ) {
  }

  ngOnInit(): void {
  }

  onBack(): void {
    this.partnerCodeInfoStepService.back();
  }

  forward(): void {
    this.partnerCodeInfoStepService.forward();
  }

  onNavigationVisibilityChange(showNavigationBack: boolean): void {
    this.hideNavigation = !showNavigationBack;
  }
}
